// Renders text with the first letter in calligraphy script font
export default function ScriptInitial({ children, className = '' }) {
  if (!children || typeof children !== 'string') {
    // If children is not a plain string, render as-is
    return <span className={className}>{children}</span>;
  }

  const first = children.charAt(0);
  const rest = children.slice(1);

  return (
    <span className={className}>
      <span className="font-script text-[1.35em] leading-none" style={{ verticalAlign: 'baseline' }}>
        {first}
      </span>
      {rest}
    </span>
  );
}
